const editingModeAction = (editingMode) => {
  return {
    type: 'SET_EDITING_MODE',
    payload: editingMode,
  }
}

export default editingModeAction
